import React, { Component } from "react";
import Headers from "../Layouts/Headers";
import { Gynecology2Sidebar } from "../Layouts/Gynecology2Sidebar";
import axios from "axios";
import $ from "jquery";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import Typography from "@mui/material/Typography";
import { CardActionArea } from "@mui/material";

export class G2UtilizationOfDrugs extends Component {
  constructor(props) {
    super(props);

   

    const url = "";

    this.state = {
      MedicationClassType: "",
      Duration: "",
      SideEffects: "",
      ContraceptiveMethods: "",
      DrugsType: "",
      DrugsSince: "",
    };

    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleChange = this.handleChange.bind(this);
  }
  handleChange(event) {
    this.setState({ [event.target.name]: event.target.value });
  }

  PrintWindow(event) {
    document.title =
      localStorage.getItem("currentVisitName") + "`s " + this.constructor.name;
    $(".modal").hide();
    window.print();
  }

  handleSubmit = (event) => {
    event.preventDefault();
    var moduleSelected = this.state["module"];
    console.log();
    const headers = {
      "Content-Type": "application/json",
      token: localStorage.getItem("accessToken"),
      visitid: localStorage.getItem("currentVisitId"),
    };

    axios
      .post(this.api_url+"gynecology2/pregnancydrugs/main", this.state, {
        headers: headers,
      })
      .then((res) => {
        //   const verified = res.data;
        console.log(res.data);
        if (res.data["status"]) {
          $(".alert-success").show();
          setTimeout(function () {
            window.location.href = "/gynecology2/sexual/history";
          }, 500);
        }
      })
      .catch((error) => {
        console.log(error);
        $('#SubmitError').show();
        $(".alert-success").hide();
      });
  };

  componentDidMount() {
    console.log(localStorage.getItem("currentVisitId"));
    //     const article = { title: 'React POST Request Example' };
    // axios.post('https://reqres.in/api/articles', article)
    // .then(response => this.setState({ articleId: response.data.id }));

    $(".sendToModule").on("click", function () {
      $(".module_list").show();
    });
  }
  render() {
    const font16 = { fontSize: "16px" };
    const fontFamilyNunito = { fontFamily: "Nunito, sans-serif" };
    const floatRight = { float: "right;" };
    const floatLeft = { float: "left;" };
    const displayHidden = { display: "none" };

    const {
      MedicationClassType,
      Duration,
      SideEffects,
      ContraceptiveMethods,
      DrugsType,
      DrugsSince,
    } = this.state;
    return (
      <div>
        <Headers />
        <Gynecology2Sidebar />

        <main className="content-container ">
          <div className="container p-2">
            <form onSubmit={this.handleSubmit}>
              <div className="form-row pt-4">
                <div className="col-md-12 text-lg-center font-weight-bold p-1">
                  <p className="text-capitalize" style={font16}>
                    Utilization of drugs in Pregnancy
                  </p>
                </div>
                <div className="col-md-6 p-2">
                  <div className="py-1">
                    <h6 className="text-capitalize" style={fontFamilyNunito}>
                      Type
                    </h6>
                    <input
                      className="form-control"
                      name="MedicationClassType"
                      value={MedicationClassType}
                      onChange={this.handleChange}
                      type="text"
                      required
                    />
                  </div>
                </div>
                <div className="col-md-6 p-2">
                  <div className="py-1">
                    <h6 className="text-capitalize" style={fontFamilyNunito}>
                      Duration
                    </h6>
                    <input
                      className="form-control"
                      name="Duration"
                      value={Duration}
                      onChange={this.handleChange}
                      type="text"
                      required
                    />
                  </div>
                </div>
                <div className="col-md-6 p-2">
                  <div className="py-1">
                    <h6 className="text-capitalize" style={fontFamilyNunito}>
                      Side Effects
                    </h6>
                    <input
                      className="form-control"
                      name="SideEffects"
                      value={SideEffects}
                      onChange={this.handleChange}
                      type="text"
                      required
                    />
                  </div>
                </div>
                <div className="col-md-6 p-2">
                  <div className="py-1">
                    <h6 className="text-capitalize" style={fontFamilyNunito}>
                      Contraceptive Methods
                    </h6>
                    <input
                      className="form-control"
                      name="ContraceptiveMethods"
                      value={ContraceptiveMethods}
                      onChange={this.handleChange}
                      type="text"
                      required
                    />
                  </div>
                </div>
              </div>

              <div className="form-row">
                <div className="col-md-6 p-2">
                  <div className="py-1">
                    <h6 className="text-capitalize" style={fontFamilyNunito}>
                      Type
                    </h6>
                    <input
                      className="form-control"
                      name="DrugsType"
                      value={DrugsType}
                      onChange={this.handleChange}
                      type="text"
                      required
                    />
                  </div>
                </div>
                <div className="col-md-6 p-2">
                  <div className="py-1">
                    <h6 className="text-capitalize" style={fontFamilyNunito}>
                      Since
                    </h6>
                    <input
                      className="form-control"
                      name="DrugsSince"
                      value={DrugsSince}
                      onChange={this.handleChange}
                      type="date"
                      required
                    />
                  </div>
                </div>
              </div>

              <div
                id="loginSuccess"
                className="alert alert-success"
                style={displayHidden}
                role="alert"
              >
                <strong>Success! </strong>Pregancy Drugs Saved Successfully.
              </div>

              <div className="row">
                {/* <div style={displayHidden} className="col col-6"><button className="btn btn-primary btn-warning rounded-pill px-4 font-weight-bold" type="button" style={floatRight}>Send To Triage</button></div> */}
                <div className="col col-6">
                  <button
                    className="btn btn-primary btn-warning rounded-pill px-5 font-weight-bold"
                    type="submit"
                    style={floatLeft}
                  >
                    Submit
                  </button>
                </div>
              </div>
            </form>
          </div>
        </main>
      </div>
    );
  }
}

export default G2UtilizationOfDrugs;
